const state = {
  storages: [],
  validStorage: {},
  pageStorCount: null,
  pageStorCurrent: null,
};

export default state;
